import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SmFormComponent } from './sm-form.component';
import { SmSubFormModule } from '../sm-sub-form/sm-sub-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SmInputModule } from '../sm-input/sm-input.module';
import { SmSelectModule } from '../sm-select/sm-select.module';
import { SmCheckboxModule } from '../sm-checkbox/sm-checkbox.module';
import { SmRadioModule } from '../sm-radio/sm-radio.module';
import { SmTextareaModule } from '../sm-textarea/sm-textarea.module';
import { SmNgSelectModule } from '../sm-ng-select/sm-ng-select.module';
import { SmSimpleTextareaModule } from '../sm-simple-textarea/sm-simple-textarea.module';
import { SmDatetimepickerModule } from '../sm-datetimepicker/sm-datetimepicker.module';
import { SmUiToolbarModule } from '../sm-ui-toolbar/sm-ui-toolbar.module';
import { SmToggleModel } from 'common/models/utility-models/meta-model';
import { SmToggleModule } from '../sm-toggle/sm-toggle.module';
import { SmLabelModule } from '../sm-label/sm-label.module';
import { SmFileModule } from '../sm-file/sm-file.module';
import { SmMultipleChoiceModule } from '../sm-multiple-choice/sm-multiple-choice.module';
import { SmDatepickerModule } from '../sm-datepicker/sm-datepicker.module';
import { SmSelectAllModule } from '../sm-select-all/sm-select-all.module';



@NgModule({
  declarations: [SmFormComponent],
  imports: [
    CommonModule,
    SmSubFormModule,
    SmInputModule,
    SmSelectModule,
    SmSelectAllModule,
    SmCheckboxModule,
    SmDatetimepickerModule,
    SmSelectModule,
    ReactiveFormsModule,
    FormsModule,
    SmRadioModule,
    SmToggleModule,
    SmTextareaModule,
    SmInputModule,
    SmUiToolbarModule,
    SmNgSelectModule,
    SmSimpleTextareaModule,
    SmLabelModule,
    SmMultipleChoiceModule,
    SmFileModule,
    SmDatepickerModule
  ],


  exports: [SmFormComponent]
})
export class SmFormModule { }
